import { clientAxios } from '@/plugins/axios'

export const sendContact = (body) => clientAxios.post('/v1/contact/complete/mail', body)
